import React, { useEffect, useState, useRef } from "react";
import StudBookFilter from "../components/StudBookFilter";
import { useNavigate, useLocation, useNavigationType } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchStudBookDatathunk,
  FetchStudBookOwnerthunk,
} from "../Redux/StudBook/StudBookAction";
import {
  emptyPage,
  incrementPage,
  resetSearch,
} from "../Redux/StudBook/StudBookSlice";

import { useTranslate } from "../components/TranslationText";

import Loader from "../components/Loader";
import HorseCard from "../components/HorseCard";
import PillBtn from "../components/PillBtn";
import SearchBox from "../components/SearchBox";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import { filterResponsive, noDataCard, rightResponsive, serviceRequestHeadContainer } from "../common/cssclasses";
import { checkIsReturning, consumeReturnTicket, setReturnTicket } from "../helper/pageFilterPersistence";

const clearStudBookSessionStorage = () => {
  sessionStorage.removeItem("sb_regNo");
  sessionStorage.removeItem("sb_selectedSearchType");
  sessionStorage.removeItem("sb_isFilterSection");
  sessionStorage.removeItem("sb_filterCriteria");
  sessionStorage.removeItem("sbf_filterState");
  sessionStorage.removeItem("sbf_searchType");
  sessionStorage.removeItem("sbf_birthDateFrom");
  sessionStorage.removeItem("sbf_birthDateTo");
  sessionStorage.removeItem("sbf_showRangeFrom");
  sessionStorage.removeItem("sbf_showRangeTo");
  sessionStorage.removeItem("sbf_searchWay");
  sessionStorage.removeItem("sbf_selectedBestHorse");
  sessionStorage.removeItem("sbf_selectedCategories");
  sessionStorage.removeItem("sbf_selectedMedals");
  sessionStorage.removeItem("sb_return_from_details");
};

const initialFilterCriteria = {
  gender: [],
  horseUELN: "",
  origin: null,
  birthDateFrom: null,
  birthDateTo: null,
  ownerId: "",
  regNo: "",
  IsBestSearch: false,
  isFlatRace: false,
  isEndurance: false,
  isLeased: null,
  HorseSearchType: null,
  ShowsFrom: null,
  ShowsTo: null,
  ShowRankIds: [],
  SearchWay: null,
  RankFrom: null,
  RankTo: null,
  MedalsList: null,
};

export default function StudBookPage() {
  const navigationType = useNavigationType();
  const location = useLocation();
  const prevLocationKey = useRef(location.key);
  const isInitialMount = useRef(true);
  const wasReturningRef = useRef(false);

  if (isInitialMount.current) {
    isInitialMount.current = false;
    const isReturningFromDetails = checkIsReturning("sb_return_from_details", navigationType, "studbook");
    wasReturningRef.current = isReturningFromDetails;
  }

  const [regNo, setRegNo] = useState(() => sessionStorage.getItem("sb_regNo") || "");
  const [isHoveredSearch, setIsHoveredSearch] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isFilterSection, setIsFilterSection] = useState(() => sessionStorage.getItem("sb_isFilterSection") === "true");

  const [isFilterimg, setIsFilterimg] = useState(true);
  const [filterCriteria, setFilterCriteria] = useState(() => {
    const saved = sessionStorage.getItem("sb_filterCriteria");
    return saved ? JSON.parse(saved) : initialFilterCriteria;
  });
  const [selectedSearchType, setSelectedSearchType] = useState(() => sessionStorage.getItem("sb_selectedSearchType") || "1");
  const [notFoundMsg, setNotFoundMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState({
    marginTop: 23,
    textAlign: "center",
    display: "none",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (wasReturningRef.current) {
      consumeReturnTicket("sb_return_from_details");
    } else {
      dispatch(resetSearch());
    }
  }, [dispatch]);

  // Handle re-clicking menu or navigating from menu while already on StudBookPage
  useEffect(() => {
    if (prevLocationKey.current !== location.key) {
      prevLocationKey.current = location.key;
      if (navigationType === "PUSH") {
        clearStudBookSessionStorage();
        setRegNo("");
        setSelectedSearchType("1");
        setIsFilterSection(false);
        setFilterCriteria(initialFilterCriteria);
        dispatch(resetSearch());
      }
    }
  }, [location.key, navigationType, dispatch]);

  useEffect(() => { sessionStorage.setItem("sb_regNo", regNo); }, [regNo]);
  useEffect(() => { sessionStorage.setItem("sb_selectedSearchType", selectedSearchType); }, [selectedSearchType]);
  useEffect(() => { sessionStorage.setItem("sb_isFilterSection", isFilterSection); }, [isFilterSection]);
  useEffect(() => { sessionStorage.setItem("sb_filterCriteria", JSON.stringify(filterCriteria)); }, [filterCriteria]);


  const {
    studBookData,
    studBookLoading,
    stateShowMoreButtonHorse,
    page,
    take,
    totalCount,
    currentLanguage,
    stateNoDataFound,
    isLoading
  } = useSelector((state) => state.studBookSlice);
  const { translate } = useTranslate();

  // console.log(studBookData);

  const filterHorses = async () => {
    if (regNo === "") {
      setErrorMsg({
        ...errorMsg,
        display: "block",
      });
    } else {
      setErrorMsg({
        ...errorMsg,
        display: "none",
      });
      dispatch(resetSearch());
    }

    //dispatch(emptyPage());
  };

  useEffect(() => {
    if (
      page === 0
    ) {
      dispatch(emptyPage());
      return; // Exit
    }
    if (selectedSearchType === "1") {
      let params = {
        regNo,
        skip: (page - 1) * take,
        take,
        langauge: currentLanguage,
        gender:
          (filterCriteria?.gender?.length ?? 0) === 0 ? null : filterCriteria.gender,
        horseUELN:
          filterCriteria?.horseUELN ? filterCriteria.horseUELN : null,
        origin: filterCriteria?.origin ? filterCriteria.origin : null,
        birthDateFrom:
          filterCriteria?.birthDateFrom ? filterCriteria.birthDateFrom : null,
        birthDateTo:
          filterCriteria?.birthDateTo ? filterCriteria.birthDateTo : null,
        ownerRegisterNumber:
          filterCriteria?.ownerId ? filterCriteria.ownerId : null,
        IsBestSearch: filterCriteria?.IsBestSearch ?? false,
        isFlatRace: filterCriteria?.isFlatRace ?? false,
        isEndurance: filterCriteria?.isEndurance ?? false,
        isLeased: filterCriteria?.isLeased ? true : null,
        HorseSearchType: filterCriteria?.HorseSearchType ?? null,
        ShowsFrom: filterCriteria?.ShowsFrom ?? null,
        ShowsTo: filterCriteria?.ShowsTo ?? null,
        ShowRankIds: filterCriteria?.ShowRankIds ?? null,
        SearchWay: filterCriteria?.SearchWay ?? null,
        RankFrom: filterCriteria?.RankFrom ?? null,
        RankTo: filterCriteria?.RankTo ?? null,
        MedalsList: filterCriteria?.MedalsList ?? null,
      };
      dispatch(FetchStudBookDatathunk(params));
      setNotFoundMsg(true);
      setErrorMsg({
        ...errorMsg,
        display: "none",
      });
    }

    if (selectedSearchType === "2") {
      setNotFoundMsg(true);
      let params = {
        ownerId: regNo,
        skip: (page - 1) * take,
        take,
        langauge: currentLanguage,
        //ownerId: filterCriteria.ownerId === "" ? null : filterCriteria.ownerId,
      };
      dispatch(FetchStudBookOwnerthunk(params));
    }
  }, [page, filterCriteria, currentLanguage]);

  const updateStudBookList = (newFilters) => {
    dispatch(emptyPage());
    const newReg = newFilters?.registrationNumber !== undefined ? newFilters.registrationNumber : regNo;
    if (newFilters?.registrationNumber !== undefined && newFilters.registrationNumber !== regNo) {
      setRegNo(newFilters.registrationNumber);
    }
    setFilterCriteria({
      ...newFilters,
      regNo: newReg,
    });
  };

  const handleChange = (e) => {
    //dispatch(resetSearch());
    //dispatch(emptypage());
    setRegNo(e.target.value);
  };

  const handleSelectedSearchType = (value) => {
    setSelectedSearchType(value);
    dispatch(resetSearch());

    if (value === "1") {
      setIsFilterimg(true);
    }

    if (value === "2") {
      setIsFilterSection(false);
      setIsFilterimg(false);
    }
  };

  const FilterSectionShow = () => {
    setIsFilterSection(!isFilterSection);
  };

  const handelShowMore = async () => {
    dispatch(incrementPage());
  };

  const langauge = localStorage.getItem("eahsLang") ?? "en";

  return (
    <React.Fragment>

      <div className={serviceRequestHeadContainer} style={{ cursor: 'pointer' }}>
        <div
          className={'col-lg-3 col-md-3 col-sm-6 col-6 pe-0 mb-main text-center'}
          id="second_most_used_services"
          onClick={() => handleSelectedSearchType("1")}
        >
          <span className={`${selectedSearchType == "1" ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.horses", "Horse")}</span>

          <div className="service_bar_underline" style={selectedSearchType == "1" ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
        </div>
        <div
          className={'col-lg-3 col-md-3 col-sm-6 col-6 ps-0 mb-main text-center '}
          id="second_registration_services"
          onClick={() => handleSelectedSearchType("2")}
        >
          <span className={`${selectedSearchType == "2" ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 20 }}>{translate("web.owner", "Owner")}</span>
          <div className="service_bar_underline" style={selectedSearchType == "2" ? { border: '3px solid #e44d52', marginTop: 16 } : {}}></div>
        </div>
        <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12 text-center ms-auto">
          <SearchBox
            onSubmit={(e) => {
              e.preventDefault();
              filterHorses();
            }}
            isFullWidth
            onChange={handleChange}
            placeholder={translate(
              "web.searchStudBook",
              "Search for StudBook, By Name Or Reg Number"
            )}
            isForm={true}
            isStudBookPage={true}
            value={regNo}
            key={'searchBox'}
            onClick={filterHorses}
            onFilterClick={FilterSectionShow}
            showMoreFilter={isFilterimg}
          />
        </div>
      </div>

      <div className="row rtl">
        {isFilterSection && (
          <div className={filterResponsive}>
            <StudBookFilter
              onSubmit={updateStudBookList}
              setRN={setRegNo}
              regNo={regNo}
              filterCriteria={filterCriteria}
            />
          </div>
        )}

        <div
          className={
            isFilterSection
              ? `row ${rightResponsive} px-0 mx-0`
              : selectedSearchType === "2"
                ? "row col-md-12 col-sm-12 px-0 mx-0"
                : "row col-md-12 col-sm-12 px-0 mx-0"
          }
        >

          {isLoading ?
            <div className="mb-5">
              <Loader />
            </div>
            :
            <>


              {!!studBookData &&
                studBookData.length > 0 &&
                selectedSearchType === "1" &&
                studBookData.map((item, i) => (
                  <HorseCard isArabicClass={true} item={item} i={i} isFilterSection={isFilterSection} />
                ))}

              {!!studBookData &&
                studBookData.length > 0 &&
                selectedSearchType === "2" &&
                studBookData.map((item, i) => (
                  OwnerCard(i, item, translate, langauge, navigate)
                ))}

              {stateNoDataFound && (
                <React.Fragment>
                  <div
                    className={
                      noDataCard
                    }
                  >
                    {translate("web.nodataFound", "No data Found!")}
                  </div>
                </React.Fragment>
              )}
              <div className="col-12 row">
                <div
                  className={'mx-auto w-unset'}
                >
                  {!studBookLoading &&
                    !!studBookData &&
                    studBookData.length > 0 ? (
                    <NewActionButton
                      disabled={stateShowMoreButtonHorse}
                      onClick={handelShowMore}
                      text={`
                    ${translate("web.showMore", "Show More")} (${studBookData.length
                        } ${translate("web.of", "of")} ${totalCount})`}
                    />
                  ) : (
                    ""
                  )}
                  {studBookLoading &&
                    <div className="mb-5">
                      <Loader />
                    </div>
                  }
                </div>
              </div>
            </>}
        </div>


      </div>
    </React.Fragment>
  );
}
function OwnerCard(i, item, translate, langauge, navigate) {
  return <div key={i} className="col-lg-3 col-md-6 col-sm-12  mb-main rtl">
    <div className="hourseCardClass p-main p-3 h-100 d-flex flex-column">
      <div className="horseCardTitle mb-1" >
        {item.name}
      </div>
      <div className="horseCardDescription">
        {translate("web.regno", "Reg No")}: {item.ownerId}
      </div>
      <div className='col-12 mt-auto'>
        <div className='mainSpacer my-2 ' />
      </div>
      <div className="row ">
        <div className="col-md-6 col-sm-6 mb-sm-0 mb-2">
          <div className='horseCardDescription fw-bold'>
            {translate("web.owns", "owns")}{" "}
            {item.numberofHorsesOwned}{" "}
            {translate("web.horses", "Horses")}
          </div>
        </div>
        <div className="col-md-6 col-sm-6">
          <div className='horseCardDescription fw-bold'>
            {translate("web.breds", "Breds")}{" "}
            {item.numberofHorsesBred}</div>
        </div>
      </div>
      <div className='col-12'>
        <div className='mainSpacer mt-2 mb-main ' />
      </div>
      <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 ms-auto" onClick={() => {
        setReturnTicket("sb_return_from_details");
        navigate(`/ownerdetails?id=${item.id || item.ownerId}&title=${encodeURIComponent(item.name || '')}`, { state: item });
      }}>
        <PillBtn isNoPadding={true} isNoMargin={true} isRed={true} text={translate("web.viewDetails", "View Details")} isNoAction={true} />
      </div>
    </div>
  </div>;
}

